import { useEffect, useState } from 'react'
import { peekPreloaded } from '@/lib/preloaded'

export interface InstructorSummary {
  id: string
  name: string
  image_url: string | null
  ride_count: number
}

// Last successful result, shown instantly when you come back to the list
// (and refreshed in the background). Without it every return starts from a
// skeleton, so the page has no avatars to morph an instructor's photo back
// into when navigating back from a detail page.
let cached: InstructorSummary[] | null = null

export function useAllInstructors() {
  const [data, setData] = useState<InstructorSummary[] | null>(() => cached ?? peekPreloaded<InstructorSummary[]>('/api/instructors'))
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false

    fetch('/api/instructors', { headers: { Accept: 'application/json' } })
      .then((response) => {
        if (!response.ok) throw new Error(`Request failed: ${response.status}`)
        return response.json() as Promise<InstructorSummary[]>
      })
      .then((json) => {
        cached = json
        if (!cancelled) setData(json)
      })
      .catch((err) => {
        if (!cancelled) setError(err instanceof Error ? err.message : 'Failed to load instructors')
      })

    return () => {
      cancelled = true
    }
  }, [])

  return { data, error }
}
